import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

export function useSearchParams<T = any>() {
  const { search } = useLocation();

  return useMemo(() => {
    const searchParams = new URLSearchParams(search);
    const params: Record<string, string> = {};

    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }

    return params as T & any;
  }, [search]);
}

/*import { useMemo } from 'react';

import { useSearchParams as useRouterSearchParams } from 'react-router-dom';

export function useSearchParams<T = Record<string, string>>() {
  const [searchParams] = useRouterSearchParams();

  return useMemo(() => {
    return Object.fromEntries(searchParams.entries()) as T;
  }, [searchParams]);
}*/
